module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_dress@2x-8ebda1e0f5caaeaf0cbe62bac33218f6.webp";